import { DateTime } from '@aibees/shared/components';
import { DATE_FORMAT_MMM_YYY, classnames } from '@aibees/shared/utils';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  timelineOppositeContentClasses,
} from '@mui/lab';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WorkHistoryTimelineProps as Props } from './types';

// TODO: here is the only usage of MUI Timeline, we need to move the custom styles to the theme overrides

export const WorkHistoryTimeline = memo(
  ({ className, items, state }: Props) => {
    if (!state.value) return null;

    return (
      <Styled.Wrapper
        className={classnames('WorkHistoryTimeline', className)}
        sx={SX.root}
      >
        <Timeline
          sx={{
            paddingRight: 0,
            marginBottom: 0,
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 0,
              padding: 0,
            },
            '&:before': {
              display: 'none',
            },
          }}
        >
          {items.map((role, roleIndex) => (
            <TimelineItem key={roleIndex} sx={{ minHeight: '32px' }}>
              <TimelineOppositeContent
                sx={{
                  paddingTop: 0,
                  paddingBottom: 0,
                }}
              />

              <TimelineSeparator
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  '& .MuiTimelineConnector-root': {
                    margin: 0,
                  },
                }}
              >
                <TimelineDot
                  sx={{
                    margin: 0,
                    padding: '1px',
                    marginTop: '5px',
                  }}
                />
                {roleIndex + 1 !== items.length && (
                  <TimelineConnector sx={{ minHeight: '100%' }} />
                )}
              </TimelineSeparator>

              <TimelineContent
                sx={{
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingRight: 0,
                }}
              >
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body4" color="grey.700">
                    {role.title}
                  </Typography>

                  <Box sx={SX.date}>
                    {role.date?.start && (
                      <DateTime
                        value={role.date.start}
                        tooltipFormat={DATE_FORMAT_MMM_YYY}
                        noTime
                        fontWeight={400}
                        variant="body5"
                        color="grey.500"
                      />
                    )}
                    <Typography
                      variant="body5"
                      color="grey.500"
                      fontWeight={400}
                    >
                      -
                    </Typography>

                    {role.date?.end && (
                      <DateTime
                        value={role.date.end}
                        tooltipFormat={DATE_FORMAT_MMM_YYY}
                        noTime
                        variant="body5"
                        color="grey.500"
                        fontWeight={400}
                      />
                    )}
                    {!role.date?.end && (
                      <Typography
                        variant="body5"
                        color="grey.500"
                        fontWeight={400}
                      >
                        Present
                      </Typography>
                    )}
                  </Box>
                </Stack>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Styled.Wrapper>
    );
  }
);

WorkHistoryTimeline.displayName = 'WorkHistoryTimeline';
